module.exports = __webpack_public_path__ + "img/jnt.5a53d4c4.png";